import React, { useEffect, useState } from "react";
import * as style from "../CreateEditRoleAPI/CreateEditRoleSidePanel.module.scss";
import {
  Divider,
  Dropdown,
  DropdownType,
} from "cprime-foundational-components";
import Typography from "../Common/CprimeText";
import { createMultiSelectRenderOption } from "../Common/multiSelectRenderOption";

interface CreateEditRoleDataDomainPanelBodyProps {
  domainOptionList?: Array<{
    domain_id: string | number;
    domain_name: string;
    subdomains: Array<{ id: number | string; name: string }>;
  }>;
  handleChange?: (data: any) => any;
  editModeData?: any;
}

interface SelectiondataDomainRestriction {
  id: string | number;
  label: string;
  allowed: Array<any>;
  restriction: Array<any>;
}

const CreateEditRoleDataDomainPanelBody: React.FC<
  CreateEditRoleDataDomainPanelBodyProps
> = ({ domainOptionList = [], handleChange = () => {}, editModeData }) => {
  const scssClass = style as any;

  const [selectedDomainOptions, setSelectedDomainOptions] =
    useState<SelectiondataDomainRestriction>({
      id: "",
      label: "",
      allowed: [],
      restriction: [],
    });

  useEffect(() => {
    if (editModeData && editModeData?.domain_id) {
      const domain = domainOptionList?.find(
        (item) => item.domain_id === editModeData.domain_id,
      );

      if (domain) {
        const allowedArray = (editModeData?.allowed_subdomains || "")
          ?.split(",")
          ?.map((item: string) => item.trim())
          ?.filter(Boolean)
          ?.map((name: string) => {
            const match = domain?.subdomains?.find((sub) => sub?.name === name);

            return {
              id: match?.id ?? null,
              label: name,
              name: name,
            };
          });

        const restrictedArray = (editModeData?.denied_subdomains || "")
          ?.split(",")
          ?.map((item: string) => item.trim())
          ?.filter(Boolean)
          ?.map((name: string) => {
            const match = domain?.subdomains?.find((sub) => sub?.name === name);

            return {
              id: match?.id ?? null,
              label: name,
              name: name,
            };
          });

        setSelectedDomainOptions({
          id: domain?.domain_id,
          label: domain?.domain_name,
          allowed: allowedArray,
          restriction: restrictedArray,
        });
      }
    }
  }, [editModeData, domainOptionList]);

  useEffect(() => {
    handleChange(selectedDomainOptions);
  }, [selectedDomainOptions]);

  const domainOptions = domainOptionList?.map((item) => ({
    id: item?.domain_id,
    label: item?.domain_name,
  }));

  const selectedDomain = domainOptionList?.find(
    (d) => d?.domain_id === selectedDomainOptions?.id,
  );

  const restrictedOptions =
    selectedDomain?.subdomains?.map((d) => ({
      ...d,
      label: d?.name,
    })) ?? [];

  const handleRestrictionChange = (field: any) => {
    setSelectedDomainOptions((prev) => ({
      ...prev,
      restriction: field,
    }));
  };

  return (
    <div>
      <Divider
        variant="fullWidth"
        sx={{
          marginBottom: "15px",
          width: "100%",
          marginLeft: "0px !important",
          backgroundColor: "#f8f8f9 !important",
        }}
      />
      <Typography className={scssClass.textDescription}>
        Feature Details
      </Typography>

      <div className={scssClass.fieldsContent}>
        {/* Domain Name (Single Select) */}
        <div>
          <Typography className={scssClass.label}>Domain Name</Typography>
          <Dropdown
            placeholder="Select"
            optionsTextLimit={200}
            fullWidth
            style={{ width: "100%" }}
            multiple={false}
            options={domainOptions}
            selectedOptions={
              selectedDomainOptions.id
                ? [
                    {
                      id: selectedDomainOptions.id,
                      label: selectedDomainOptions.label,
                    },
                  ]
                : []
            }
            onChange={(field) => {
              const selected = field[0];
              setSelectedDomainOptions({
                id: selected.id,
                label: selected.label,
                allowed: [],
                restriction: [],
              });
            }}
          />
        </div>

        {/* Allowed (Multi Select) */}
        {/* <div>
          <Typography className={scssClass.label}>Allowed</Typography>
          <Dropdown
            placeholder="Select"
            optionsTextLimit={200}
            style={{ width: "100%" }}
            multiple={true}
            type={DropdownType.MultiSelect}
            options={allowedOptions}
            selectedOptions={selectedDomainOptions.allowed}
            onChange={(field) => {
              setSelectedDomainOptions((prev) => ({
                ...prev,
                allowed: field,
              }));
            }}
          />
        </div> */}

        {/* Restricted (Multi Select) */}
        <div>
          <Typography className={scssClass.label}>Restricted</Typography>
          <Dropdown
            placeholder="Select"
            optionsTextLimit={200}
            style={{ width: "100%" }}
            fullWidth
            multiple={true}
            type={DropdownType.MultiSelect}
            disableCloseOnSelect
            options={restrictedOptions}
            selectedOptions={selectedDomainOptions.restriction}
            onChange={handleRestrictionChange}
            renderOption={createMultiSelectRenderOption(
              selectedDomainOptions.restriction,
              handleRestrictionChange,
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateEditRoleDataDomainPanelBody;
